<template>
  <div class="right-cart" v-bind:class="{open: isCartOpen}">
    <div class="cart-inner" style="">
      <div class="jagged"></div>
      <div id="basket" class="pt-20 pt15 px-10">
        <div class="cart-contain">
          <div class="h-full flex flex-col">
            <div class=" close-cart" style=""><a href="javascript: void(0);" @click="showHideCart(false)">{{$t('button_close')}}</a>
            </div>
            <div class="heading-dotted p10 ">
              <span class="lg-cond">{{$t('cart.your_basket')}}</span>
            </div>
            <div class="text-center"><span class="t12 ">({{$t('cart.include_tax_message')}})</span></div>
            <!--<div class="basket-memo">{{$t('cart.make_change')}}</div>-->
            <div class="cart-item-contain pb-10" style="">
              <div class="cart-item t13 67" data-original-title="" title="">
                <p class="pl-10 pt-10 pr-10 typo-l7" v-if="cart.hasOwnProperty('data') && cart.data.length == 0">
                  {{$t('cart.your_basket_empty_1')}}
                </p>
                <!-- ##########################################################-->
                <div class="main-item">
                  <transition-group name="fade1">
                    <div v-for="(data) in cart.data"
                         :key="genUniqueKey(data)"
                         class="flex1 per-item"
                         v-bind:item="data.id">
                      <!-- ################# Show combo item ############# -->
                      <div href="javascript: void(0)" @click.stop="editCombo(data)"
                           v-if="data.product_type == $const.CARD_ITEM_TYPE.COMBO" class="cursor-pointer">
                        <div class="fw600 py-10">
                          <span class="block-left">
                            <span class="menu-price-sub" v-if="data.quantity > 1">{{$t('format_product_not_quantity',{
                                  product_name: data.name || '',
                                  quantity: data.quantity
                                })}}
                            </span>
                            <span class="menu-price-sub" v-else>{{data.name}}</span>
                          </span>
                          <div class="cart-quantity"
                              v-on:click="ModifyQuantity(data, $event)">
                            x {{ data.quantity }}
                          </div>
                          <div class=" block-right block-top">
                            <span>{{$const.CURRENCY}} {{formatNumDisplay(data.sub_total)}}
                              <a @click.prevent.stop="removeCart(data)" href="javascript:void(0)" class="cart-remove">
                                <img src="../../assets/images/icons/remove.svg" alt="remove">
                                <!--<i class="fas fa-trash"></i>-->
                              </a>
                            </span>
                          </div>
                          <div class="clearfix"></div>
                        </div>

                        <div class="" v-for="(item) in data.items" v-bind:key="item.id" v-bind:item="item">
                          <div v-for="(gItem) in item.group_items" v-bind:key="gItem.group_id">
                            <div class="content  cl-78838c">
                              <div class="fw600 basket-item-product">
                                <span class="flex justify-between items-center mr-30">{{(gItem.layer_info ? gItem.layer_info.first ? gItem.layer_info.first.name : '' : '') +' '+ (gItem.name)}}</span>
                              </div>
                            </div>
                            <div class="content cl-78838c" v-if="gItem.layer_info && gItem.layer_info.second">
                              <span class="block-left"><span class="menu-price-sub">{{(gItem.layer_info.second.name ? gItem.layer_info.second.name : '')}}</span></span>
                              <div class="fw600 block-right t13 menu-price-sub"
                                   v-if="gItem.layer_info.second.price > 0">
                                <span>{{$const.CURRENCY}} {{formatNumDisplay(gItem.layer_info.second.price)}}</span>
                              </div>
                              <div class="clearfix"></div>
                            </div>
                            <div v-if="gItem.toppings != null">
                              <div v-for="(subitem) in gItem.toppings.extra" :key="genUniqueKey(subitem)"
                                   class="content  cl-78838c" v-if="subitem.special == '1'">
                                <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                                <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                  <span>{{$const.CURRENCY}} {{formatNumDisplay(subitem.price * subitem.quantity)}}</span>
                                </div>
                                <div class="clearfix"></div>
                              </div>
                              <div v-for="(subitem) in gItem.toppings.extra" :key="genUniqueKey(subitem)"
                                   class="content  cl-78838c" v-if="subitem.special != '1'">
                                <span class="block-left">
                                  <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{$t('cart.add')+' '+(subitem.name)}}</span>
                                  <span class="menu-price-sub" v-else>{{ $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: $t('cart.add')+' '+(subitem.name)
                                              })}}</span>

                                </span>
                                <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                  <span>{{$const.CURRENCY}} {{formatNumDisplay(subitem.price * subitem.quantity)}}</span>
                                </div>
                                <div class="clearfix"></div>
                              </div>
                              <div v-for="(subitem) in gItem.toppings.remove" :key="genUniqueKey(subitem)"
                                   class="content  cl-78838c">
                                <span class="block-left"><span class="menu-price-sub">{{$t('cart.remove')+' '+(subitem.name)}}</span></span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <!-- ################# Show combo item ############# -->

                      <!-- ################# Show single item ############# -->
                      <div v-if="data.product_type == $const.CARD_ITEM_TYPE.SINGLE && data.menu_type !== $const.CARD_ITEM_TYPE.BAG" @click.stop="editSingle(data)"
                           class="cursor-pointer">
                        <div class="fw600 py-10">
                          <span class="block-left">
                            <span class="menu-price-sub">
                              {{ formatName(data) }}
                            </span>
                          </span>
                          <div class="cart-quantity"
                              v-on:click="ModifyQuantity(data, $event)">
                            x {{ data.quantity }}
                          </div>
                          <div class=" block-right block-top">
                            <span class="top-price">
                              {{
                                (data.sub_total === 0 && data.menu_type === $const.CARD_ITEM_TYPE.FREE) ? $t('free') : $t('currency_display', {
                                    currency: $const.CURRENCY,
                                    amount: formatNumDisplay(data.sub_total)
                                })
                              }}
                              <a @click.prevent.stop="removeCart(data)" href="javascript:void(0)" class="cart-remove">
                                <img src="../../assets/images/icons/remove.svg" alt="remove">
                                <!--<i class="fa fa-trash"></i>-->
                              </a>
                            </span>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="content  cl-78838c" v-if="data.items.length > 0 && data.items[0].layer_info.second">
                          <span class="block-left"><span class="menu-price-sub">{{(data.items[0].layer_info.second.name ? data.items[0].layer_info.second.name : '')}}</span></span>
                          <div class="fw600 block-right t13 menu-price-sub"
                               v-if="data.items[0].layer_info.second.price > 0">
                              <span>
                                {{
                                  $t('currency_display', {
                                      currency: $const.CURRENCY,
                                      amount: formatNumDisplay(data.items[0].layer_info.second.price)
                                  })
                                }}
                              </span>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div v-if="data.items[0].toppings != null && data.items[0].toppings.extra">
                          <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                               class="content  cl-78838c" v-if="subitem.special == '1'">
                            <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                            <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                <span>
                                  {{
                                    $t('currency_display', {
                                        currency: $const.CURRENCY,
                                        amount: formatNumDisplay(subitem.price * subitem.quantity)
                                    })
                                  }}
                                </span>
                            </div>
                            <div class="clearfix"></div>
                          </div>

                          <div class="topping-box"
                               v-if="data.items[0].toppings.extra && data.items[0].toppings.extra.length">
                            <div class="heading">{{$t('cart.plasting')}}</div>
                            <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                                 class="content  cl-78838c" v-if="subitem.special != '1'">
                              <span class="block-left">
                                <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{(subitem.name)}}</span>
                                <span class="menu-price-sub" v-else>{{
                                              $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: (subitem.name)
                                              })
                                            }}</span>
                              </span>
                              <div class="fw600 block-right t13 menu-price-sub" v-if="subitem.price > 0">
                                          <span>
                                            {{
                                              $t('currency_display', {
                                                  currency: $const.CURRENCY,
                                                  amount: formatNumDisplay(subitem.price * subitem.quantity)
                                              })
                                            }}
                                          </span>
                              </div>
                              <div class="clearfix"></div>
                            </div>
                          </div>

                          <div class="topping-box"
                               v-if="data.items[0].toppings.remove && data.items[0].toppings.remove.length">
                            <div class="heading">{{$t('cart.minus')}}</div>
                            <div v-for="(subitem) in data.items[0].toppings.remove" :key="genUniqueKey(subitem)"
                                 class="content  cl-78838c">
                              <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                              <div class="clearfix"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- ################# Show single item ############# -->

                      <!-- ################# Show half item ############# -->
                      <div v-if="data.product_type == $const.CARD_ITEM_TYPE.HALF" @click.stop="editSingle(data, true)">
                        <div class="fw600 py-10">
                          <span class="block-left">
                            <span class="menu-price-sub" v-if="data.quantity > 1">{{formatName(data)}}</span>
                            <span class="menu-price-sub" v-else>{{(data.name)}}</span>
                          </span>
                          <div class="cart-quantity"
                               v-on:click="ModifyQuantity(data, $event)">
                            x {{ data.quantity }}
                          </div>
                          <div class=" block-right block-top">

                            <span class="top-price">
                              {{
                                $t('currency_display', {
                                    currency: $const.CURRENCY,
                                    amount: formatNumDisplay(data.sub_total)
                                })
                              }}
                              <a @click.prevent.stop="removeCart(data)" href="javascript:void(0)" class="cart-remove">
                                <img src="../../assets/images/icons/remove.svg" alt="remove">
                              </a>
                            </span>
                          </div>
                          <div class="clearfix"></div>
                        </div>

                        <!-- show left -->
                        <div class="" v-if="data.items.length > 0" v-bind:key="data.items[0].id"
                             v-bind:item="data.items[0]">
                          <div class="cart-half content  cl-78838c" v-if="data.items[0].name">
                            <div class="half-item">
                              <span class="fw600 block-left">
                                <span class="menu-left-sub">
  <!--
                                  {{ $t('left_half')+' ('+((data.items.length > 0 && data.items[0].layer_info) ? data.items[0].layer_info.first_name : '')+' '+(data.items[0].name)+')' }}
  -->
                                  {{ $t('left_half') }}
                                </span>
                              </span>
                              <div class=" block-right">
                                <span class="">
                                  {{
                                    $t('currency_display', {
                                        currency: $const.CURRENCY,
                                        amount: formatNumDisplay(data.items[0].layer_info.second.price)
                                    })
                                  }}
                                </span>
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left">
                                  <span class="menu-price-sub">
                                  {{ formatName(data.items[0], true) }}
                                  </span>
                                </span>
                                <div class="clearfix"></div>
                              </div>
                            </div>
                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left"><span class="menu-price-sub">{{((data.items.length > 0 && data.items[0].layer_info && data.items[0].layer_info.second) ? data.items[0].layer_info.second.name : '')}}</span></span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-topping">
                              <div v-if="data.items[0].toppings != null && data.items[0].toppings.extra">
                                <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special == '1'">
                                  <span class="block-left"><span class="menu-price-sub">{{(subitem.name)}}</span></span>
                                  <div class=" block-right" v-if="subitem.price > 0"><span class="">+ {{$const.CURRENCY}} {{formatNumDisplay(subitem.price * subitem.quantity)}} </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-for="(subitem) in data.items[0].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special != '1'">
                                  <span class="block-left">
                                    <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{(subitem.name)}}</span>
                                    <span class="menu-price-sub" v-else>{{
                                              $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: (subitem.name)
                                              })
                                            }}</span>
                                  </span>
                                  <div class=" block-right" v-if="subitem.price > 0">
                                    <span class="">
                                        {{
                                          $t('currency_display', {
                                              currency: $const.CURRENCY,
                                              amount: formatNumDisplay(subitem.price * subitem.quantity)
                                          })
                                        }}
                                    </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-if="data.items[0].toppings && data.items[0].toppings.remove">
                                  <div v-for="(subitem) in data.items[0].toppings.remove" :key="genUniqueKey(subitem)"
                                       class="content  cl-78838c">
                                    <span class="block-left"><span class="menu-price-sub">{{$t('cart.remove')+' '+(subitem.name)}}</span></span>
                                    <div class="clearfix"></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                        <!-- show left -->

                        <!-- show right -->
                        <div v-if="data.items.length > 0" v-bind:key="data.items[1].id" v-bind:item="data.items[1]">
                          <div class="cart-half content  cl-78838c" v-if="data.items[1].name">
                            <div class="half-item">
                              <span class="fw600 block-left"><span class="menu-right-sub">
                                <!--{{$t('right_half')+' ('+((data.items.length > 0 && data.items[1].layer_info) ? data.items[1].layer_info.first_name : '')+' '+(data.items[1].name)+')'}}-->
                                {{ $t('right_half') }}
                              </span></span>
                              <div class=" block-right">
                                <span class="">
                                  {{
                                    $t('currency_display', {
                                        currency: $const.CURRENCY,
                                        amount: formatNumDisplay(data.items[1].layer_info.second.price)
                                    })
                                  }}
                                </span>
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left">
                                  <span class="menu-price-sub">{{ formatName(data.items[1], true) }}</span>
                                </span>
                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-sub-item">
                              <div class="content  cl-78838c">
                                <span class="block-left"><span class="menu-price-sub">{{((data.items.length > 0 && data.items[1].layer_info && data.items[1].layer_info.second) ? data.items[1].layer_info.second.name : '')}}</span></span>

                                <div class="clearfix"></div>
                              </div>
                            </div>

                            <div class="half-topping">
                              <div v-if="data.items[1].toppings != null && data.items[1].toppings.extra">
                                <div v-for="(subitem) in data.items[1].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special == '1'">
                                  <span class="block-left">
                                    <span class="menu-price-sub">{{(subitem.name)}}</span>
                                  </span>
                                  <div class=" block-right" v-if="subitem.price > 0">
                                    <span class="">
                                      {{
                                        $t('currency_display', {
                                            currency: $const.CURRENCY,
                                            amount: formatNumDisplay(subitem.price * subitem.quantity)
                                        })
                                      }}
                                    </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-for="(subitem) in data.items[1].toppings.extra" :key="genUniqueKey(subitem)"
                                     class="content  cl-78838c" v-if="subitem.special != '1'">
                                  <span class="block-left">
                                    <span class="menu-price-sub" v-if="subitem.quantity <= 1">{{(subitem.name)}}</span>
                                    <span class="menu-price-sub" v-else>{{
                                              $t('format_product', {
                                                  quantity: subitem.quantity,
                                                  product_name: (subitem.name)
                                              })
                                            }}</span>
                                  </span>
                                  <div class=" block-right" v-if="subitem.price > 0">
                                    <span class="">
                                      {{
                                        $t('currency_display', {
                                            currency: $const.CURRENCY,
                                            amount: formatNumDisplay(subitem.price * subitem.quantity)
                                        })
                                      }}
                                    </span>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>

                                <div v-if="data.items[1].toppings && data.items[1].toppings.remove">
                                  <div v-for="(subitem) in data.items[1].toppings.remove" :key="genUniqueKey(subitem)"
                                       class="content  cl-78838c">
                                    <span class="block-left"><span
                                      class="menu-price-sub">{{$t('cart.remove')+' '+(subitem.name)}}</span></span>
                                    <div class="clearfix"></div>
                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                        <!-- show right -->
                      </div>
                      <!-- ################# Show half item ############# -->
                      <!-- ################# Show slice used ############# -->
                      <div v-if="data.menu_type === $const.CARD_ITEM_TYPE.FREE && data.point" style="color: #c8102e" class="d-flex align-items-center mt-5">
                        <img src="https://static.phdvasia.com/jp/hut-rewards/left_icon.png" class="image-icon" style="margin-right: 2px">
                        {{$tc('slices_redeem', (data.point * data.quantity), {slices: (data.point * data.quantity)})}}
                      </div>
                    </div>
                  </transition-group>
                  <!-- plastic bags -->
                  <div class="plastic-bag mt-10 mb-20" v-if="showPlasticBag && plasticBag"
                    :class="((cart.data || []).length > 0 && cart.is_show_cutlery && cutleries.length > 0) && 'plastic-bag-border-bottom' "
                  >
                    <div class="display-flex" style="justify-content: space-between;">
                      <div class="pt-15 col-10">
                        <p class="fw600 t14">{{ plasticBag.name }}</p>
                      </div>
                      <div class="pt-15 col-2">
                        <label class="xs-block">
                          <input v-model="isPlasticBag" class="checkbox" type="checkbox" @change="() => updatePlastic()" >
                          <i class="icon-checkbox-cart"></i>
                        </label>
                      </div>
                    </div>
                    <div class="display-flex" >
                      <div style="margin-right: 30px;" v-if="plasticBag.marketing_description">
                        {{ plasticBag.marketing_description }}
                      </div>
                      <div class="">
                        {{$const.CURRENCY}}{{(plasticBag.price || plasticBag.item_price)}}
                      </div>
                    </div>
                    <!-- <div v-if="plasticBag.marketing_description" class="pb-20">{{ plasticBag.marketing_description }}</div> -->
                    <!-- increase and decrease bags -->
                    <!-- <div v-if="isPlasticBag" class="display-flex mb-20" style="justify-content: space-between;">
                      <div class="display-flex">
                        <span class="pr-15 t24 pl-15 btn-decrease-bag btn-bag"
                          :style="plasticBag.quantity > 1 ? 'color: #70a401' : 'color: #b8babe'"
                          @click.stop="increaseAndDecreaseBags()"
                          >
                          &#8722;
                        </span>
                        <span class="t16 pl-10 pr-10">{{plasticBag.quantity}}</span>
                        <span class="pl-15 t24 btn-increase-bag btn-bag"
                          style="color: #70a401"
                          @click.stop="increaseAndDecreaseBags(true)"
                          >
                            +
                        </span>
                      </div>
                      <div>{{$const.CURRENCY}}{{(plasticBag.price || plasticBag.item_price) * plasticBag.quantity}}</div>
                    </div> -->
                  </div>
                  <!-- plastic bags -->
                  <!-- ################# Show cutlery ############# -->
                  <div v-if="(cart.data || []).length > 0 && cart.is_show_cutlery && cutleries.length > 0"
                    class="per-itemp item-coupon no-remove l-10 pt-10 t14 fw600 mt-10 ">
                  <label class="display-flex fw600" style="width: 100%"
                         for="extraCutlery" v-for="cutlery in cutleries" :key="genUniqueKey(cutlery)">
                    <div style="margin-top: -8px">
                      <img class="set-with-height" v-if="isMobile()" :src="cutlery.image_mobile" alt="">
                      <img class="set-with-height" v-else :src="cutlery.image_desktop" alt="">
                    </div>
                    <div class="block-left flex1 display-flex flex-row pull-left">
                      <span style="margin-right: 5px">{{cutlery.name}}</span>
                    </div>
                    <div class="block-right " >
                      <input class="xs-block rounded xs-p-5 checkbox extraCondiment" id="extraCutlery"
                             name="extra_condiment" :true-value="1" :false-value="0"
                             v-model="cart.is_use_cutlery" v-on:change="updateCartData" type="checkbox">
                      <i class="pull-right icon-checkbox-cart"></i>
                    </div>
                  </label>
                  </div>
                  <!-- <transition-group name="fade3"  v-show="0">
                    <div
                      v-for="(data) in cutleryData"
                        :key="genUniqueKey(data)"
                        class="content flex1 "
                        v-bind:item="data.id">
                      <div class="fw600 fw400 py-10 cl-78838c" style="width: 100%">
                        <span class="block-left">
                          <span class="menu-price-sub" v-if="data.quantity > 1">{{$t('format_product_not_quantity',{
                                product_name: data.name || '',
                                quantity: data.quantity
                              })}}
                          </span>
                          <span class="menu-price-sub" v-else>{{data.name}}</span>
                        </span>
                        <div class="cart-quantity" @click="ModifyQuantity(data, $event,'cutlery')">
                          x {{ data.quantity }}
                        </div>
                        <div class=" block-right block-top">
                        <span v-if="data.sub_total">{{$const.CURRENCY}}{{formatNumDisplay(data.sub_total)}}
                        </span>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </transition-group> -->
                  <span v-if="(cart.data || []).length > 0 && cart.is_show_cutlery && cutleries.length > 0">{{message_cutlerry_condiment}}</span>
                  </div>
                  <!-- ################# End Show cutlery ############# -->

                <!-- ##########################################################-->
                <div class="per-item item-coupon no-remove pt-10 t14 fw600">
                  <div class="display-flex" style="width: 100%">
                    <div class="block-left flex1 display-flex flex-row">{{$t('cart.subtotal')}}</div>
                    <div class="block-right ">
                        <span class="t16">{{$const.CURRENCY}}
                          <span class="t16 " id="sub_total_price">
                            {{ formatNumDisplay(subtotalIncludeTax) }}
                          </span>
                        </span>
                    </div>
                  </div>
                </div>

                <!-- show coupon -->
                <div v-if="cart.coupon"
                     class="t14 fw600 coupon-cart-item pt-10 pr-10"
                     style="display: block">
                  <div v-for="coupon in cart.coupon.data"
                       :key="genUniqueKey(coupon)"
                       class="per-item item-coupon " style="width: 100%">
                    <div v-if="(!_.includes($const.COUPON_TYPES.CIRCLE_DISCOUNT, coupon.discount_type))"
                         class="content">
                      <div class="block-left flex1 display-flex flex-row">
                        <span v-if="!coupon.is_auto && coupon.discount_value <= 0">{{ $t('cart.couponvalue0') + ": " }}</span>
                        <span v-else-if="!coupon.is_auto">{{ $t('cart.discount') + ": " }}</span>
                        <span class="code">{{ coupon.is_auto ? coupon.display_name : coupon.code}}</span>
                      </div>

                      <div v-if="coupon.discount_quantity && coupon.discount_quantity > 0"
                           class="cart-quantity">
                        x {{coupon.discount_quantity}}
                      </div>
                      <div class="block-right flex1 display-flex flex-row">
                        <div v-if="coupon.discount_type == $const.COUPON_TYPE_FREE_DELIVERY"
                             class="menu-price-sub">
                          <span class="t16">{{$t('cart.free_delivery')}}</span>
                        </div>
                        <div v-else-if="(coupon.discount_type != $const.COUPON_TYPE_ITEM && coupon.circle_discount_type != 'free_item')"
                             class="menu-price-sub">
                          <div class="t16" v-if="coupon.discount_value > 0">
                            {{$const.CURRENCY}}
                            <span class="t16">{{formatNumDisplay(coupon.discount_value)}}</span>
                          </div>
                        </div>
                      </div>

                      <a @click="removeCoupon(coupon.code)" href="javascript:void(0)" class="pl-5 cart-remove"
                         v-if="!coupon.is_auto">
                        <img src="../../assets/images/icons/remove.svg" alt="remove">
                      </a>
                    </div>

                  </div>
                </div>
                <!-- end show coupon -->

                <!-- show delivery fee -->
                <div class="per-itemp item-coupon no-remove l-10 pt-10 t14 fw600" v-if="$const.FLAG_DELIVERY_FEE && $disposition.getByKey(this, 'orderType', '') === $const.DELIVERY">
                  <div class="display-flex" style="width: 100%">
                    <div class="block-left flex1 display-flex flex-row">
                      {{$t('cart.delivery_fee')}}
                    </div>
                    <div class="block-right ">
                        <span class="t16">{{$const.CURRENCY}}
                          <span class="t16 ">{{ formatNumDisplay(cart.delivery_fee) }}</span>
                        </span>
                    </div>
                  </div>
                </div>
                <!-- end show delivery fee -->
                
                <!-- show service fee -->
                <div class="per-itemp item-coupon no-remove l-10 pt-10 pr-10 t14 fw600" v-if="$const.FLAG_SERVICE_FEE && orderType == $const.DELIVERY && cart.service_fee > 0">
                  <div class="display-flex" style="width: 100%">
                    <div class="block-left flex1 display-flex flex-row">
                      {{cart.service_fee_name[$session.get('lang')]}}
                    </div>
                    <div class="block-right ">
                        <span class="t16">{{$const.CURRENCY}}
                          <span class="t16 ">{{ formatNumDisplay(cart.service_fee) }}</span>
                        </span>
                    </div>
                  </div>
                </div>
                <!-- end show service fee -->
              </div>

              <div class="cart-total pt-10 t14 fw600" v-if="totalIncludeTax > 0">
                <div class="display-flex pr-10">
                  <div class="flex1">{{$t('cart.total')}}</div>
                  <span class="t18">
                  {{
                    $t('currency_display', {
                        currency: $const.CURRENCY,
                        amount: formatNumDisplay(totalIncludeTax)
                    })
                  }}
                </span>
                </div>
              </div>
              <div class="cart-item t14 fw600" v-if="cart.total > 0">
                <div class="display-flex pr-10">
                  <div class="flex1">{{$t('cart.service_tax')}}</div>
                  <span class="t16">
                  {{
                    $t('currency_display', {
                        currency: $const.CURRENCY,
                        amount: formatNumDisplayDownRound(consumptionTax)
                    })
                  }}
                </span>
                </div>
              </div>
              <div class="padding-left-right-5 mt-10">
                <a v-if="user"
                   v-on:click="showHideCart(false);redirectTo('category', {slug: $const.HEADER_MENU.COUPON})"
                   class="btn btn--secondary choose-coupon-list mt-10 mb-15">
                  <img src="https://static.pizzahut.jp/jp/icons/coupon-choose.png">
                  {{ $t('choose_coupon_list') }}
                </a>
              </div>
              <!-- redeem category  -->
            <div class="hut-rewards-redeem-category container-new-ui" v-if="$auth.check()">
              <div class="hut-rewards-redeem-header d-flex justify-content-between bg-hut-rewards-redeem">
                <img src="https://static.phdvasia.com/jp/header/logo-hut-rewards.svg" alt="logo hut rewards">
                <div>
                  <img v-if="getRankInfoUser(rank).iconRank" :src="getRankInfoUser(rank).iconRank" alt="icon-rank" width="25" >
                  <span>{{$tc('header.infoSlices', hutReward.point, {slice: hutReward.point})}}</span>
                </div>
              </div>
              <div class="redeem-hut-rewards-slides-wrap vuecarousel-redeem" v-if="!isMaintainance">
                <p v-if="dataCategory.length !== 0" class="redeem-hut-rewards-text mb-0 d-flex align-items-center" @click="showRedeemCategory()">
                  <i class="fa fa-lg pr-2" :class="isExtendRedeem ? 'fa-angle-down' : 'fa-angle-up'" aria-hidden="true"></i>
                  {{$t("redeem_category_title")}}
                </p>
                <div class="carouselFreeItemWrapper" v-if="isExtendRedeem && dataCategory.length !== 0">
                  <a @click="$refs.carouselFreeSide.prev()" class="left carousel-control" href="#" data-slide="prev"
                    style="width: 25px; height: 86px; margin-left: -18px !important;">
                    <span class="glyphicon glyphicon-chevron-left"></span>
                    <span class="sr-only">{{$t('button_previous')}}</span>
                  </a>
                  <VueSlickCarousel
                    ref="carouselFreeSide"
                    :arrows="false"
                    :dots="false"
                    :slidesToShow="1.9"
                    :slidesToScroll="1"
                    :centerPadding="'20px'"
                    :swipeToSlide="false"
                    :infinite="true"
                    :variableWidth="false"
                    :autoplay="true"
                    :autoplaySpeed="3000"
                    :pauseOnDotsHover="true"
                    :pauseOnFocus="true"
                    :pauseOnHover="true"
                  >
                    <div v-for="(item, idx) in dataCategory" :key="idx"
                    >
                      <card-item
                        class="vuecarousel-item"
                        :item="item"
                        :isMaxRedeem="sumOfHutRewardInCart(cart) >= getMaxItemHutReward"
                        @fncRedeem="() => goToRedeem(item)"/>
                    </div>
                  </VueSlickCarousel>
                  <a @click="$refs.carouselFreeSide.next()" class="right carousel-control" href="#" data-slide="next"
                    style="width: 25px; height: 86px; margin-right: -18px !important;">
                    <span class="glyphicon glyphicon-chevron-right"></span>
                    <span class="sr-only">{{$t('button_next')}}</span>
                  </a>
                </div>
              </div>
              <div class="text-left content " :class="cart.banner_image ? 'mt-30 mb-30' : 'bg-hut-rewards-redeem mt-2'">
                <img v-if="cart.banner_image" class="mb-15" v-bind:src="cart.banner_image">
                <p v-if="cart.hut_reward_point && cart.hut_reward_point != cart.hut_regular_reward_point" class="mb-0" style="text-align: center" v-html="$t('redeem_promotions_cart_slices', {slices: cart.hut_regular_reward_point, money: currentSlices.addMore, promotionSlices: cart.hut_reward_point})"></p>
                <p v-else class="mb-0" style="text-align: center" v-html="$tc('redeem_category_cart_slices', cart.hut_reward_point || currentSlices.current, {slices: cart.hut_reward_point || currentSlices.current, money: currentSlices.addMore})"></p>
              </div>
            </div>
            <!-- redeem category -->
            </div>
            <div class="addons-cart show-addons" v-if="true"
              :class="{'has-min-cart-alert': !checkMinCart()}">
              <div class="hungry-title container-shake-animation">
                {{$t("hungry_more")}}
              </div>
              <!--##############################-Silder-####################### -->
              <div class="carousel-inner carousel slide " v-if="slides.length > 0 ">

                <vueper-slides :autoplay="true" ref="myCarousel" :touchable="is_mobile ? true : false" :bullets="false" :pauseOnHover="true">
                  <vueper-slide v-for="slide in slides" :key="slide.id">
                    <div slot="slideContent">
                      <div class="item item-addon">

                        <!--ITEM'S IMAGE-->
                        <figure class="image item-addon__img">
                          <img style="" :alt="slide.name" v-bind:src="slide.imagelink">
                        </figure>
                        <!--ITEM'S IMAGE-->


                        <!--ITEM'S NAME-->
                        <div class="name item-addon__info">
                          <h5 class="item-addon__txt" style="margin-bottom: 10px">{{slide.name}}</h5>
                          <p class="item-addon__txt" style="color: rgb(112, 164, 1)"><span>{{$const.CURRENCY}}</span>{{slide.baseprice}}</p>
                        </div>
                        <!--./ITEM'S NAME-->


                        <!--ITEM'S PRICE-->
<!--                        <div class="price item-addon__txt" style="">-->
<!--                          -->
<!--                        </div>-->
                        <!--./ITEM'S PRICE-->


                        <!--Add-to-cart button-->
                        <div class="button item-addon__btn">
                          <button class="btn btn--primary btn--sm btn-add-single-item-addon t13" @click="AddAddOnToCart(slide)"
                                  style="padding: 8px 7px">{{$t('button_add_now')}}
                          </button>
                        </div>
                        <!--./Add-to-cart button-->
                      </div>
                    </div>
                  </vueper-slide>
                </vueper-slides>
              </div>
              <!--##############################-Silder-####################### -->
              <a @click="$refs.myCarousel.previous()" class="left carousel-control" href="#" data-slide="prev"
                 style="width: 25px;">
                <span class="glyphicon glyphicon-chevron-left"></span>
                <span class="sr-only">{{$t('button_previous')}}</span>
              </a>
              <a @click="$refs.myCarousel.next()" class="right carousel-control" href="#" data-slide="next"
                 style="width: 25px;">
                <span class="glyphicon glyphicon-chevron-right"></span>
                <span class="sr-only">{{$t('button_next')}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-checkout checkout-out  margin-bottom">
      <div style="width: 100%; margin: auto">
        <button class="btn btn--primary btn--lg show-basket" v-if="(is_mobile && (!isCartOpen || cart.total < 0))"
                @click="showHideCart(true)">
          <div class="float-l min-cart" v-if="cart.data != null && getTotalItem() > 0">
            <span class="num">{{cart.data ? getTotalItem() : 0}}</span>
          </div>
          {{$t('button_view_basket')}}
          <span class="float-r" v-if="cart.total > 0">{{$const.CURRENCY}}{{formatNumDisplay(cart.total)}}</span>
        </button>
        <div v-else class="display-flex group-button-cart-checkout flex-column">
          <button class="btn btn--primary btn--lg"
                  :class="{'disabled': cart.total <= 0}"
                  @click="(cart.total > 0) && checkout()" style="">
            <div class="float-l min-cart" v-if="cart.data != null && getTotalItem() > 0">
              <span class="num">{{cart.data ? getTotalItem() : 0}}</span>
            </div>
            {{$t('button_checkout')}}
          </button>
          <p class="text-center item-btn t13 mt-5" v-if="!checkMinCart()">
            {{
            $t('format_mincart', {
            currency: $const.CURRENCY,
            amount: getRequiredMinCart()
            })
            }}
          </p>
        </div>
        <div>
          <img src="https://static.pizzahut.jp/jp/icons/payment-methods-logo.jpg" alt="payment-logo">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/vueperslides.min.css'
import voucher from '../popup/ModalVoucher.vue'
import ModalPopup from '../popup/ModalPizza'
import ModalUpdateCart from '../popup/ModalUpdateCart'
import CardItem from '../cards/CardItem'
import * as types from '@/store/types'
import { VueperSlides, VueperSlide } from 'vueperslides'
import PopupNotifyHut from '@/components/popup/PopupNotifyHut'
import {
  mapGetters,
  mapActions
} from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  created () {
    this.checkCutlery()
  },
  mounted() {
    let vm = this
    const user = this.$auth.user()
    vm.rank = vm.getValueFromAttr(user, 'membership_id', 6)
    vm.getAddOn()
    this.$cart.init(this)
    this.$root.$on('cartUpdate', () => {
      vm.$cart.init(vm)
      vm.calculateTotal(vm.cart)
      vm.updateCartData()
    })
    this.$root.$on('getDetail', () => {
      this.$cart.getDetail(this)
    })
    if (this.$session.get('orderType')) {
      this.orderType = this.$session.get('orderType')
    }
    vm.calculateTotal(vm.cart)
    this.$root.$on('couponItemImplement', (data) => {
      if (data) {
        if (data.is_combo) {
          // check router because sometime it appear a error "NavigationDuplicated: Avoided redundant navigation to current location"
          if (vm.$route.name === 'combo-detail') {
            return false
          } else {
            vm.$router.push({name: 'combo-detail', params: {nameseo: data.menu[0].uuid || '', ssid: 'coupon', coupon: data.coupon}}).catch(() => {})
          }
        } else {
          vm.show(data.menu[0], '', data.coupon)
        }
      }
    })
    this.$root.$on('onRedirectToHome', () => {
      vm.$router.push({'name': 'home'})
    })
    this.$root.$on('cartAddItem', (data) => {
      vm.AddToCart(data)
    })

    this.$root.$on('showHideCart', (flag) => {
      vm.showHideCart(flag)
    })
    window.addEventListener('resize', function (e) {
      vm.resizeCart()
      vm.is_mobile = vm.isMobile()
    })
    vm.is_mobile = vm.isMobile()
    vm.resizeCart()
    if (vm.$auth.check()) {
      vm.getListCategoryFreeRank()
      if (vm.cart.uuid) {
        vm.$cart.getDetail(vm)
      }
    }
  },
  beforeDestroy () {
    document.body.classList.remove('modal-open-cart')
  },
  data () {
    return {
      subtotalIncludeTax: 0,
      totalIncludeTax: 0,
      consumptionTax: 0,
      isShowBtnCheckOut: false,
      isCartOpen: false,
      is_mobile: false,
      addonsBottom: -15,
      slides: [],
      dataCategory: [],
      isExtendRedeem: true,
      rank: 0,
      display_payment_cart: '',
      isShowPaymentOnCart: true,
      isMaintainance: false,
      freeItemHutReward: null,
      message_cutlerry_condiment: '',
      cutleries: [],
      orderType: this.$const.DELIVERY,
      plasticBag: this.$session.get('plasticBags'),
      showPlasticBag: false,
      isPlasticBag: false,
      isStopClick: false
    }
  },
  computed: {
    ...mapGetters({
      selectedProductByCart: 'selectedProductByCart',
      user: 'user',
      currentSlices: types.GET_SLICES_REWARD,
      hutReward: types.GET_HUT_REWARD,
      maintainanceHutReward: types.GET_MAINTAINANCE_HUT_REWARD,
      getMaxItemHutReward: types.GET_MAX_ITEM_HUT_REWARD
    })
  },
  watch: {
    selectedCategory: function (newValue, oldValue) {

    },
    selectedSubCategory: function (newValue, oldValue) {

    },
    maintainanceHutReward () {
      this.isMaintainance = this.checkMaintainanceHutReward(this.maintainanceHutReward.start_time, this.maintainanceHutReward.end_time)
      if (this.isMaintainance) {
        this.dataCategory.forEach(item => {
          item.isDisabled = true
        })
      }
    }
    // cart: function () {
    //   this.setMessageCulleryCondiment()
    // }
  },
  methods: {
    ...mapActions({
      setSelectedCart: types.SET_SELECTED_CART,
      setSlicesReward: types.SET_SLICES_REWARD,
      setHutReward: types.SET_HUT_REWARD
    }),
    updatePlastic () {
      if (this.isPlasticBag) {
        this.AddAddOnToCart(this.plasticBag)
      } else {
        this.removeCart(this.plasticBag)
        this.plasticBag = null
        this.isPlasticBag = false
      }
    },
    increaseAndDecreaseBags (increase) {
      if (!this.isStopClick) {
        this.isStopClick = true
        if (!increase && this.plasticBag.quantity === 1) {
          this.isStopClick = false
          return false
        } else {
          let quantity = increase ? this.plasticBag.quantity += 1 : this.plasticBag.quantity -= 1
          this.$cart.updateQuantity(this, {
            item_id: this.plasticBag.id,
            quantity: quantity
          }, () => { this.isStopClick = false })
        }
      }
    },
    goToRedeem (item) {
      this.eventClickedOnRedeemInCart()
      if (!this.checkPosition(this)) {
        const path = this.$route.fullPath.indexOf('/') !== 0 ? this.$route.fullPath : this.$route.fullPath
        this.$router.push({'name': 'home', query: {isShowWarning: 1, callback: path}})
        return
      }
      this.isMaintainance = this.checkMaintainanceHutReward(this.maintainanceHutReward.start_time, this.maintainanceHutReward.end_time)
      if (this.isMaintainance) {
        this.dataCategory.forEach(item => {
          item.isDisabled = true
        })
        this.showMaintainance(this.maintainanceHutReward.start_time, this.maintainanceHutReward.end_time)
      } else {
        this.$router.push({name: 'free_side', params: {uuid: item.uuid}})
      }
    },
    setMessageCulleryCondiment() {
      this.message_cutlerry_condiment = this.getMessageFromGms({error:{code:'isNotUseCutlery'}}) ? this.getMessageFromGms({error:{code:'isNotUseCutlery'}}) :this.$t('isNotUseCutlery')
      if (this.cart.is_use_cutlery) {
        this.message_cutlerry_condiment = this.getMessageFromGms({error:{code:'isUseCutlery'}}) ? this.getMessageFromGms({error:{code:'isUseCutlery'}}) :  this.$t('isUseCutlery')
      }
    },
    checkCutlery () {
      let vm = this
      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      let params = {
        'order_type': vm.$cart.order_type,
        'order_time': orderTime,
        'outlet_code': vm.getOutletCode(vm)
      }
      vm.axios.apiMenu.getCutlery(params, function (response) {
        let items = response.data.data.items
        if (items.length > 0) {
          for (let i in items) {
            vm.cutleries.push({
              name: items[i].name,
              image_desktop: items[i].image.desktop_thumbnail ? items[i].image.desktop_thumbnail : items[i].image.desktop_detail,
              image_mobile: items[i].image.mobile_thumbnail ? items[i].image.mobile_thumbnail : items[i].image.mobile_detail
            })
          }
        }
        vm.setMessageCulleryCondiment()
      })
    },
    /**
     * Update cart
     * */
      updateCartData() {
      let cart = this.$cart.get(this)
      // cart['is_use_condiment'] = this.cart.is_use_condiment
      cart['is_use_cutlery'] = this.cart.is_use_cutlery
      // cart['is_show_condiment'] = this.cart.is_show_condiment
      cart['is_show_cutlery'] = this.cart.is_show_cutlery
      this.setMessageCulleryCondiment()
      this.$session.set('cart', cart)
      this.$cart.updateCartUuid(this, true)
    },
    showMaintainance (startTime, endTime) {
      let vm = this
      this.$modal.show(PopupNotifyHut, {
        title: vm.$t('title_maintain'),
        text: vm.$t('text_maintain', {startTime, endTime}),
        alignTitle: 'start',
        btnTitleAction: vm.$t('text_okay'),
        fncAction: () => {},
        iconTitle: 'https://static.phdvasia.com/jp/hut-rewards/warning-icon.png'
      },
      {
        class: 'modal-hut-notify', transition: 'nice-modal-fade', overlayTransition: 'overlay-fade'
      })
    },
    calculateTotal (data) {
      let subtotalIncludeTax8 = 0
      let subtotalIncludeTax10 = 0
      let totalIncludeTax8 = 0
      let totalIncludeTax10 = 0
      let tax8 = 0
      let tax10 = 0
      let discount = data.total_discount || 0
      this.freeItemHutReward = null
      for (let i in data.data) {
        let item = data.data[i]
        let quantity = item.quantity
        if (item.product_type == this.$const.CARD_ITEM_TYPE.SINGLE) { // single
          if (item.items.length > 0) {
            for (let index in item.items) {
              let _menu = item.items[index]
              // adding menu
              if (_menu.tax_rate == this.$const.TAX.TAX10) {
                subtotalIncludeTax10 += _menu.base_price * quantity
              } else {
                subtotalIncludeTax8 += _menu.base_price * quantity
              }
              // adding size
              if (_menu.layer_info && Object.keys(_menu.layer_info).length > 0 && _menu.layer_info.hasOwnProperty('first') && !this.empty(_menu.layer_info.first)) {
                // size
                if (_menu.layer_info.first.tax_rate == this.$const.TAX.TAX10) {
                  subtotalIncludeTax10 += _menu.layer_info.first.price * quantity
                } else {
                  subtotalIncludeTax8 += _menu.layer_info.first.price * quantity
                }
              }
              // adding crust
              if (_menu.layer_info && Object.keys(_menu.layer_info).length > 0 && _menu.layer_info.hasOwnProperty('second') && !this.empty(_menu.layer_info.second)) {
                // size
                if (_menu.layer_info.second.tax_rate == this.$const.TAX.TAX10) {
                  subtotalIncludeTax10 += _menu.layer_info.second.price * quantity
                } else {
                  subtotalIncludeTax8 += _menu.layer_info.second.price * quantity
                }
              }
              // adding topping
              if (_menu.toppings.extra && _menu.toppings.extra.length > 0) {
                for (let extra in _menu.toppings.extra) {
                  if (_menu.layer_info.second.tax_rate == this.$const.TAX.TAX10) {
                    subtotalIncludeTax10 += _menu.toppings.extra[extra].price * _menu.toppings.extra[extra].quantity * quantity
                  } else {
                    subtotalIncludeTax8 += _menu.toppings.extra[extra].price * _menu.toppings.extra[extra].quantity * quantity

                  }
                }
              }
            }
          }
        } else if (item.product_type == this.$const.CARD_ITEM_TYPE.COMBO) {
          // adding combo
          if (item.tax_rate == this.$const.TAX.TAX10) {
            subtotalIncludeTax10 += item.base_price * quantity
          } else {
            subtotalIncludeTax8 += item.base_price * quantity
          }
          if (item.items.length > 0) {
            for (let indexC in item.items) {
              for (let indexG in item.items[indexC].group_items) {
                let _menu = item.items[indexC].group_items[indexG]
                // adding menu
                if (_menu.tax_rate == this.$const.TAX.TAX10) {
                  subtotalIncludeTax10 += _menu.base_price * quantity
                } else {
                  subtotalIncludeTax8 += _menu.base_price * quantity
                }
                // adding size
                if (_menu.layer_info && Object.keys(_menu.layer_info).length > 0 && _menu.layer_info.hasOwnProperty('first') && !this.empty(_menu.layer_info.first)) {
                  // size
                  if (_menu.layer_info.first.tax_rate == this.$const.TAX.TAX10) {
                    subtotalIncludeTax10 += _menu.layer_info.first.price * quantity
                  } else {
                    subtotalIncludeTax8 += _menu.layer_info.first.price * quantity
                  }
                }
                // adding crust
                if (_menu.layer_info && Object.keys(_menu.layer_info).length > 0 && _menu.layer_info.hasOwnProperty('second') && !this.empty(_menu.layer_info.second)) {
                  // size
                  if (_menu.layer_info.second.tax_rate == this.$const.TAX.TAX10) {
                    subtotalIncludeTax10 += _menu.layer_info.second.price * quantity
                  } else {
                    subtotalIncludeTax8 += _menu.layer_info.second.price * quantity
                  }
                }
                // adding topping
                if (_menu.toppings.extra && _menu.toppings.extra.length > 0) {
                  for (let extra in _menu.toppings.extra) {
                    if (_menu.layer_info.second.tax_rate == this.$const.TAX.TAX10) {
                      subtotalIncludeTax10 += _menu.toppings.extra[extra].price * _menu.toppings.extra[extra].quantity * quantity
                    } else {
                      subtotalIncludeTax8 += _menu.toppings.extra[extra].price * _menu.toppings.extra[extra].quantity * quantity
                    }
                  }
                }
              }
            }
          }
        } else if (item.product_type == this.$const.CARD_ITEM_TYPE.HALF) {
          // adding half-half
          if (item.tax_rate == this.$const.TAX.TAX10) {
            subtotalIncludeTax10 += item.base_price * quantity
          } else {
            subtotalIncludeTax8 += item.base_price * quantity
          }
          if (item.items.length > 0) {
            for (let index in item.items) {
              let _menu = item.items[index]
              // adding menu
              if (_menu.tax_rate == this.$const.TAX.TAX10) {
                subtotalIncludeTax10 += _menu.base_price * quantity
              } else {
                subtotalIncludeTax8 += _menu.base_price * quantity
              }
              // adding size
              if (_menu.layer_info && Object.keys(_menu.layer_info).length > 0 && _menu.layer_info.hasOwnProperty('first') && !this.empty(_menu.layer_info.first)) {
                // size
                if (_menu.layer_info.first.tax_rate == this.$const.TAX.TAX10) {
                  subtotalIncludeTax10 += _menu.layer_info.first.price * quantity
                } else {
                  subtotalIncludeTax8 += _menu.layer_info.first.price * quantity
                }
              }
              // adding crust
              if (_menu.layer_info && Object.keys(_menu.layer_info).length > 0 && _menu.layer_info.hasOwnProperty('second') && !this.empty(_menu.layer_info.second)) {
                // size
                if (_menu.layer_info.second.tax_rate == this.$const.TAX.TAX10) {
                  subtotalIncludeTax10 += _menu.layer_info.second.price * quantity
                } else {
                  subtotalIncludeTax8 += _menu.layer_info.second.price * quantity
                }
              }
              // adding topping
              if (_menu.toppings.extra && _menu.toppings.extra.length > 0) {
                for (let extra in _menu.toppings.extra) {
                  if (_menu.layer_info.second.tax_rate == this.$const.TAX.TAX10) {
                    subtotalIncludeTax10 += _menu.toppings.extra[extra].price * _menu.toppings.extra[extra].quantity * quantity
                  } else {
                    subtotalIncludeTax8 += _menu.toppings.extra[extra].price * _menu.toppings.extra[extra].quantity * quantity
                  }
                }
              }
            }
          }
        }
        if (item.menu_type === this.$const.CARD_ITEM_TYPE.FREE) {
          this.eventRewardItemApplied()
          this.freeItemHutReward = item
        }
        if (item.menu_type === this.$const.CARD_ITEM_TYPE.BAG) {
          this.isPlasticBag = true
          this.$session.set('plasticBags', {
            marketing_description: (this.plasticBag && this.plasticBag.marketing_description) || '',
            uuid: this.plasticBag.uuid,
            ...item
          })
          this.plasticBag = this.$session.get('plasticBags')
        }
      }
      this.subtotalIncludeTax = subtotalIncludeTax8 + subtotalIncludeTax10
      totalIncludeTax8 = subtotalIncludeTax8
      totalIncludeTax10 = subtotalIncludeTax10
      if (discount > 0) {
        totalIncludeTax8 = subtotalIncludeTax8 - discount
        if (totalIncludeTax8 < 0) {
          totalIncludeTax8 = 0
          discount -= subtotalIncludeTax8
        } else if (subtotalIncludeTax8 > 0) {
          discount = 0
        }
        if (discount > 0) {
          totalIncludeTax10 = subtotalIncludeTax10 - discount
        }
      }
      tax8 = totalIncludeTax8 - (totalIncludeTax8 / this.$const.TAX.TAXRATE8)
      tax10 = totalIncludeTax10 - (totalIncludeTax10 / this.$const.TAX.TAXRATE10) + (this.cart.delivery_fee / this.$const.TAX.TAXDELIVERYFEE) + (this.$cart.order_type === 'D' ? this.cart.service_fee / this.$const.TAX.TAXSERVICEFEE : 0)
      this.totalIncludeTax = totalIncludeTax8 + totalIncludeTax10 + this.cart.delivery_fee + (this.$cart.order_type === 'D' ? this.cart.service_fee : 0)
      let totalCalculateSlice = this.$disposition.getByKey(this, 'orderType', '') === this.$const.DELIVERY ? data.sub_total : this.totalIncludeTax
      let sliceLast = this.convertTotalPriceToSlice(this, this.cart.sub_total)
      this.setSlicesReward(sliceLast)
      this.consumptionTax = Math.floor(tax8) + Math.floor(tax10)
      const user = this.$auth.user()
      if (this.cart.hut_reward_used !== undefined) {
        this.setHutReward({
          ...this.hutReward,
          point: user.point - this.cart.hut_reward_used
        })
      }
      this.$root.$emit('resetSlicesHeader')
      this.getListCategoryFreeRank()
      if (this.totalIncludeTax > 0) {
        if (this.cart.data.length === 1 && this.cart.data[0].menu_type === this.$const.CARD_ITEM_TYPE.BAG) {
          this.removeItem(this.cart.data[0])
          this.showPlasticBag = false
          this.plasticBag = null
        } else {
          this.plasticBag = this.$session.get('plasticBags')
          this.showPlasticBag = true
          let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
            this.$disposition.getByKey(this, 'collectionTimeValue', ''))
          if (!orderTime) {
            orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.plasticBag && (orderTime > this.plasticBag.selling_end)) {
            this.isPlasticBag = false
          }
          if (this.cart.data.length > 0) {
            let isExistPlasticBag = false
            for (let i = 0; i < this.cart.data.length; i++) {
              const item = this.cart.data[i]
              if (item.menu_type === this.$const.CARD_ITEM_TYPE.BAG) {
                isExistPlasticBag = true
              }
            }
            this.isPlasticBag = isExistPlasticBag
          }
        }
      } else {
        this.plasticBag = null
        this.isPlasticBag = false
      }
      if (!this.plasticBag) {
        this.isPlasticBag = false
      }
    },
    getAddOn () {
      let vm = this
      let data = vm.getMenuRequest()
      data.single_type = 1

      vm.axios.getAddOnByCategory(data, function (response) {
        let items = response.data.data.items;
        // let singles = items[0].singles
        items.map((single)=>{
          let category = single.display_categories && single.display_categories.length > 0 ? single.display_categories[0].uuid : ''
          let data = {}
          data = {
            "id": single.id,
            "item": single,
            "name": single.name,
            "imagelink": single.image.desktop_thumbnail,
            "baseprice": single.min_price,
            "min_price": single.min_price,
            "promotionprice": single.display_price,
            "uuid": single.uuid,
            "toppings": single.toppings,
            "category_id": category,
            "selling_start": single.selling_start
          }
          vm.slides.push(data)
        })
      })
    },
    getRequiredMinCart () {
      let amount = 0
      let orderType = this.$disposition.getByKey(this, 'orderType', '')
      let minCart = this.$disposition.getByKey(this, 'minCart', '')
      let orderTypeShort = (orderType == this.$const.CARRYOUT) ? 'C' : 'D'

      if (this.empty(minCart) || !minCart.hasOwnProperty(orderTypeShort) || minCart[orderTypeShort] <= 0) {
        amount = 0
      } else {
        amount = minCart[orderTypeShort] || 0
      }

      if (!isNaN(amount)) {
        amount = this.formatNumDisplay(amount)
      }

      return amount
    },
    checkMinCart() {
      let orderType = this.$disposition.getByKey(this, 'orderType', '')
      let minCart = this.$disposition.getByKey(this, 'minCart', '')
      let orderTypeShort = (orderType == this.$const.CARRYOUT) ? 'C' : 'D'

      if (this.empty(minCart) || !minCart.hasOwnProperty(orderTypeShort) || minCart[orderTypeShort] <= 0) {
        return true
      }
      minCart = minCart[orderTypeShort]

      let cartTotal = orderTypeShort === 'D' ? this.cart.sub_total : this.cart.total
      if (cartTotal >= minCart && cartTotal > 0) {
        return true
      }

      return false
    },
    /**
     * Add item to cart
     * */
    ModifyQuantity(item, event) {
      event.stopPropagation()

      let vm = this
      if (item.coupon_code) {
        let coupon = null;
        let list = vm.cart.coupon.data;

        if (list) {
          for (let c in list) {
            if (list[c].code == item.coupon_code) {
              coupon = list[c]
              break;
            }
          }
        }

        if (coupon) {
          if (vm._.includes(this.$const.COUPON_TYPES.FREE_GIFT, coupon.discount_type)) {
            return false
          } else if (vm._.includes(this.$const.COUPON_TYPES.CIRCLE_DISCOUNT, coupon.discount_type) &&
            coupon.discount_quantity && !coupon.discount_value) {
            return false
          }
        }
      }
      this.$modal.show(ModalUpdateCart, {
          title: item.name,
          min: 1,
          max: 99,
          value: item.quantity,
          inputDisabled: true,
          hutRewardUsed: vm.cart.hut_reward_used,
          isHutReward: item.menu_type === this.$const.CARD_ITEM_TYPE.FREE,
          customize: item.customize,
          point: item.point,
          update: function (data) {
            if (data && data > 0) {
              let quantity = Math.abs(data - item.quantity)
              let uuid = item.combo_uuid
              let variants = []
              let variantId = ''
              if (item.items.length > 0) {
                for (let i in item.items) {
                  if (item.items[i].layer_info && item.items[0].layer_info.first) {
                    variants.push(item.items[0].layer_info.first.uuid)
                    if (item.items.length == 1) {
                      variantId += item.items[0].layer_info.first.uuid
                      if (item.items[i].layer_info && item.items[0].layer_info.second) {
                        variantId += '-' + item.items[0].layer_info.second.uuid
                      }
                    }
                  }
                  uuid = uuid || item.items[i].product_uuid
                }
              }
              if (item.quantity > data) {
                let pro = {
                  id: uuid,
                  name: item.name,
                  variants: variants,
                  quantity: quantity,
                  selected_category_name_en: item.selected_category_name_en || ''
                }
                this.eventTrackingRemoveFromCart(pro)
              } else if (item.quantity < data) {
                let pro = {
                  item: item,
                  id: uuid,
                  quantity: quantity,
                  variantId: variantId
                }
                this.eventTrackingUpdateQuantityFromCart(pro)
              }
              this.$cart.updateQuantity(this, {
                item_id: item.id,
                quantity: data
              })
            }
          }
        },
        {
          'class': 'modal-update-cart'
        },
        {
          'before-open': function () {
            document.body.classList.add('modal-open')
          },
          'before-close': function () {
            document.body.classList.remove('modal-open')
          }
        })

    },
    formatName(data, isHalf = false) {
      let text = '';
      if (isHalf) {
        text += "(" + data.layer_info.first.name + ") " + data.name;
      } else {
        if (data.items.length) {
          if (data.items[0].layer_info && data.items[0].layer_info.first) {
            text = data.items[0].layer_info.first.name;
          }

          text += " " + (data.name || '');
        }
      }


      return text;
    },
    formatSize(val) {
      if (val) {
        val = val.toLowerCase();
        if (val == "medium") {
          return "M size";
        } else if (val == "large") {
          return "L size";
        }
      }
    },
    AddAddOnToCart(data) {
      let item = {
        "group": {},
        "products": []
      }

      item.group['outlet_code'] = this.$disposition.getByKey(this,'outletCode','')
      item.group['tier'] = this.$cart.tier
      item.group['order_type'] = this.$cart.order_type
      item.group['order_time'] = this.getTimePickerDate(this)
      item.group['product_type'] = this.$const.CARD_ITEM_TYPE.SINGLE
      item.group['combo_id'] = ''
      item.group['quantity'] = 1

      item.selling_start = data.selling_start

      let products = {}
      products.category_id = data.category_id
      products.combo_group_id = null
      products.product_id = data.uuid
      products.first_id = ""//this.choosedFirst.uuid
      products.second_id = ""//this.choosedSecond.uuid
      products.toppings = {}
      products.toppings.remove = [] //this.$cart.getToppingById(this.removeYourTopping)
      products.toppings.extra = [] //this.$cart.getToppingById(this.addExtraTopping)
      item.products.push(products)

      let pro = {
        item: data,
        id: data.uuid,
        name: data.name,
        price: data.baseprice,
        first: {},
        second: {},
        context: 'upsell'
      }
      let proClick = this._.cloneDeep(data)
      proClick.variant_uuid = ''
      this.evenTrackingProductClick(this, proClick, 'direct-product-selection-sidebar-basket-crossell')
      this.eventTrackingAddToCart(this, pro, 'main', this.$const.CARD_ITEM_TYPE.SINGLE, 'direct-product-selection-sidebar-basket-crossell')
      this.$cart.insert(this, item, () => { this.isPlasticBag = false })
    },
    /**
     * Remove item from cart
     * */
    removeCart (item) {
      if (item.menu_type === this.$const.CARD_ITEM_TYPE.FREE) {
        let vm = this
        this.$modal.show(PopupNotifyHut, {
          title: vm.$t('remove_free_sides_title', {name: item.name}),
          text: vm.$t('remove_free_sides_text'),
          alignTitle: 'left',
          btnTitleAction: vm.$t('btn_remove_free_sides'),
          btnTitleCancel: vm.$t('btn_cancel'),
          fncAction: () => {
            vm.eventRewardItemRemoved()
            vm.removeItem(item)
          },
          fncCancel: () => {
            vm.eventRewardItemCancel()
          }
        },
        {
          class: 'modal-hut-notify', transition: 'nice-modal-fade', overlayTransition: 'overlay-fade'
        })
      } else {
        this.removeItem(item)
      }
    },
    removeItem (item) {
      this.$cart.remove(this, item.id)
      let variants = []
      let uuid = item.combo_uuid
      if (item.items.length > 0) {
        for (let i in item.items) {
          if (item.items[i].layer_info && item.items[0].layer_info.first) {
            variants.push(item.items[0].layer_info.first.uuid)
          }
          if (item.items[i].layer_info && item.items[0].layer_info.second) {
            variants.push(item.items[0].layer_info.second.uuid)
          }
          uuid = uuid || item.items[i].product_uuid
        }
      }
      let pro = {
        id: uuid,
        name: item.name,
        half_half_id: item.half_half_id,
        variants: [variants.join('-')],
        quantity: item.quantity,
        selected_category_name_en: item.selected_category_name_en || ''
      }
      this.eventTrackingRemoveFromCart(pro)
    },
    removeCoupon(code) {
      this.$cart.removeCoupon(this, {coupon_code: code})
    },
    /**
     * Show modal voucher
     * */
    showModalVoucher() {
      if (!this.checkPosition(this)) {
        this.$router.push('/?isShowWarning=1')
        return false
      }
      this.$modal.show(voucher, {},
        {
          'class': 'modal-coupon'
        },
        {
          'before-open': function () {
            document.body.classList.add('modal-open')
          },
          'before-close': function () {
            document.body.classList.remove('modal-open')
          }
        })
    },
    /**
     * Add item to cart
     * */
    addItemOtherComponents(item) {
      this.$cart.insert(this, item)
    },
    /**
     * Show/Hide cart info
     * */
    showHideCart(flag) {
      this.isCartOpen = flag
      if (flag) {
        document.body.classList.add('modal-open-cart')
      } else {
        document.body.classList.remove('modal-open-cart')
      }
      this.resizeCart()
    },
    /**
     * Trigger resize window
     * */
    resizeCart() {
      if (document.documentElement.clientWidth > 768) {
        this.addonsBottom = 75
      } else {
        if (this.isCartOpen) {
          let container = this.$el.querySelector('.checkout-out')
          let nav = document.body.querySelector('#nav')
          this.addonsBottom = container.scrollHeight + nav.scrollHeight - 15
        } else {
          this.addonsBottom = -15
        }
      }
    },
    /**
     * Check out
     * */
    checkout() {
      let vm = this
      if (this.cart.total <= 0) {
        this.$notify({
          type: 'warn',
          title: this.$t('please_add_more_food')
        })

        return false
      }

      if (!this.checkMinCart()) {
        this.$notify({
          type: 'warn',
          title: this.$t('format_mincart', {currency: this.$const.CURRENCY, amount: this.getRequiredMinCart()})
        })
        return false
      }

      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }

      let paramOutlet = {
        outlet_code: this.$disposition.getByKey(this, 'outletCode', ''),
        address_code: this.$disposition.getByKey(this, 'addressCode', '')
      }

      document.body.classList.remove('modal-open-cart');
      // if (this.$cart.order_type !== 'D') {
      //   this.$router.push({'name': 'checkout'})
      // } else {
        // this.$cart.checkout(this, this.cart.uuid, orderTime)
      // }
      if (this.orderType === vm.$const.DELIVERY) {
        this.axios.apiOutlet.checkAddressCode(paramOutlet,
          function (response) {
            vm.$cart.checkout(vm, vm.cart.uuid, orderTime)
          }, function (error) {
            vm.$modal.show('dialog', {
              text: vm.getMessageFromGms(error),
              buttons: [
                {
                  title: vm.$t('button_yes'),
                  handler: () => {
                    vm.$modal.hide('dialog')
                    vm.$session.remove('cart')
                    vm.$session.remove('disposition')
                    localStorage.removeItem(vm.$const.SESSION_CHECK_ADDRESS_CODE)
                    vm.$root.$emit('cartUpdate')
                    vm.$root.$emit('onReInitHeader')
                    vm.$router.push({'name': 'home'})
                  }
                }
              ]
            })
          })
      } else {
        this.$cart.checkout(this, this.cart.uuid, orderTime)
      }
    },
    getTotalItem() {
      let quantity = 0
      for (let i in this.cart.data) {
        if(this.cart.data[i].product_type != this.$const.PRODUCT_TYPE_CONDIMENT &&
          this.cart.data[i].product_type != this.$const.PRODUCT_TYPE_CUTLERRY) {
          quantity += this.cart.data[i].quantity
        }
          
      }
      return quantity
    },
    editSingle(menu, isHalf = false) {
      if (isHalf) {
        return false;
      }
      this.$store.dispatch(types.SET_SELECTED_SIZE, menu.items[0].layer_info.first)
      this.$store.dispatch(types.SET_SELECTED_CRUST, menu.items[0].layer_info.second)

      if (menu.coupon_code) {
        return false
      }

      this.setSelectedCart({
        cartId: menu.id,
        productUuid: (menu.items && menu.items.length) ? menu.items[0].product_uuid : null,
        isHalf: isHalf,
        nameSeo: menu.friendly_seo_name || ''
      })
    },
    editCombo(menu) {
      if (menu.coupon_code) {
        return false
      }
      // close Cart to prevent crash layout
      this.showHideCart(false)
      this.$router.push({name: 'combo-detail', params: {nameseo: menu.combo_uuid || '', ssid: menu.id}})
    },
    /**
     * Show modal popup
     * */
    show(item, itemId, coupon, isHalf = false) {
      if (!isHalf) {
        this.$modal.show(ModalPopup, {
          menu: item,
          coupon: coupon || '',
          scrollable: false,
          mfirst: {},
          msecond: {},
          itemId: itemId,
          extraCheese: []
        }, {
          class: 'modal-menu',
          transition: 'nice-modal-fade',
          overlayTransition: 'overlay-fade',
          clickToClose: false,
          name: 'close-modal-menu'
        }, {
          'before-open': this.beforeOpen,
          'before-close': this.beforeClose
        })
        let pro = {
          id: item.id,
          name: item.name,
          price: this.checkNum(item.min_price),
          brand: 'Google',
          cat: item.category_id,
          variant: '',
          position: 1
        }
      } else {
        this.$modal.show(ModalPopupHalf, {
          menu: this.item,
          scrollable: false,
          mfirst: this.mode == 'list' && this.$route.params.slug == this.$const.MENU_PIZZA ? this.selectedVariant.first || {} : {},
          msecond: this.mode == 'list' && this.$route.params.slug == this.$const.MENU_PIZZA ? this.selectedVariant.second || {} : {},
          extraCheese: []
        }, {
          class: 'modal-menu',
          transition: 'nice-modal-fade',
          overlayTransition: 'overlay-fade',
          clickToClose: false,
          name: 'close-modal-menu'
        }, {
          'before-open': this.beforeOpen,
          'before-close': this.beforeClose
        })
      }

    },
    /**
     * Trigger before open modal popup
     * */
    beforeOpen(event) {
      document.body.classList.add('modal-open')
    },
    /**
     * Trigger before close modal popup
     * */
    beforeClose(event) {
      document.body.classList.remove('modal-open')
    },
    showRedeemCategory() {
      this.isExtendRedeem = !this.isExtendRedeem
    },
    getListCategoryFreeRank () {
      let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''),
        this.$disposition.getByKey(this, 'collectionTimeValue', ''))
      if (!orderTime) {
        orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      }
      let vm = this
      // system category have cache about 2 minutes
      orderTime = this.addTimeToClearCache(orderTime)
      let request = {
        order_time: orderTime,
        lang: vm.$session.get('lang'),
        order_type: vm.$disposition.getByKey(vm, 'orderType', 'D').charAt(0),
        outlet_code: vm.getOutletCode(vm),
        membership_id: vm.$auth.user().membership_id
      }

      vm.axios.getCategoryLoyalty(request, function (response) {
        const listCategory = response.data.data.items
        if (listCategory.length > 0) {
          vm.dataCategory = listCategory.map(item => {
            return {
              logo: item.image.banner,
              title: item.name,
              price: vm.parseNumberSlices(item.customize),
              isDisabled: (vm.checkAvailableSlices(item.customize) || vm.isMaintainance) ? true : false,
              uuid: item.uuid,
              displayType: item.display_type
            }
          })
          vm.$session.set('listCategoryMembership', vm.dataCategory)
        }
      })
    },
    checkAvailableSlices (customize) {
      let point = typeof (this.hutReward.point) === 'undefined' ? this.$auth.user().point : this.hutReward.point
      point = parseInt(point)
      let min = (customize && customize.min_point) ? parseInt(customize.min_point) : ''
      if (customize && min && point && typeof (min) === 'number') {
        return point < min
      } else return true
    },
    parseNumberSlices (customize) {
      if (customize && customize.min_point && customize.max_point) {
        let min = parseInt(customize.min_point)
        let max = parseInt(customize.max_point)
        if (typeof (min) === 'number' && typeof (max) === 'number') {
          if (min < max) {
            return this.$t('min_max_slices', {slices: `${customize.min_point} - ${customize.max_point}`})
          } else if (min === max) {
            return this.$t('min_max_slices', {slices: customize.min_point})
          }
        }
      }
      return ''
    }
  },
  components: { VueperSlides, VueperSlide, CardItem, VueSlickCarousel }
}

</script>
<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .carousel-control.left {
    top: 50px;
    margin-left: -3px !important;
  }

  .carousel-control.right {
    top: 50px;
    margin-right: -3px !important;
  }

  .min-cart {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.2);
    padding: 0px 9px;
  }
  .card-item-redeem {
    padding-left: 5px;
    padding-right: 5px;
  }
  .vuecarousel-redeem {
    padding-left: 5px;
    padding-right: 5px;
  }
  .vuecarousel-redeem .vuecarousel-item {
    margin: auto;
    width: 140px;
  }
  .vuecarousel-redeem .vuecarousel-item .btn-danger {
    width: 100%;
  }
  .applied-free-item-box {
   background: #E7F2E9;
    padding: 12px 14px;
    border-radius: 5px;
    margin-left: 5px;
    margin-right: 5px;
  }
  .applied-free-item-box .check-icon {
    color: #E7F2E9;
    padding: 4px;
    background: #70A401;
    border-radius: 50%;
    margin-right: 7px;
  }
  .carouselFreeItemWrapper {
    position: relative;
    padding-left: 10px;
    padding-right: 8px;
    margin-bottom: 16px;
  }

  .set-with-height {
    width: 32px;
    height: 32px;
  }
  .icon-checkbox-cart:before {
    border-radius: 5px;
    width: 18px;
    height: 18px;
  }
  .checkbox:checked + .icon-checkbox-cart::after{
    content: "";
    width: 8px;
    height: 10px;
    position: absolute;
    left: 5px;
    top: 3px;
    background-color: #ffffff;
    border-radius: 0;
    border: solid #70a401;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(38deg);
    transform: rotate(38deg);
  }
  .plastic-bag {
    border-top: 1px solid #eeeeee;
  }
  .plastic-bag-border-bottom {
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 16px;
  }
  .plastic-bag i.icon-checkbox-cart {
    margin-right: 0px;
  }
  .btn-bag {
    cursor: pointer;
  }
  .checkbox + i {
    margin-right: 0px;
  }
@media (max-width: 600px) {
  .carouselFreeItemWrapper {
    overflow: hidden;
    padding-left: 0px;
    padding-right: 0px;
  }
  .vuecarousel-redeem .vuecarousel-item {
    margin: auto;
    width: 165px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Cart.vue